import { getTranslations } from "cpl-react-common/i18n";

const translations = getTranslations("en");

export default translations;
